export default "__VITE_ASSET__C9639qJc__"